import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/DefaultMarkdownPage.js";
import AllBrands from '../ui/brands/AllBrands';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "what-is-react"
    }}><a parentName="h1" {...{
        "href": "#what-is-react",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`What is React?`}</h1>
    <strong>And how can I explain it to my boss?</strong>
    <p>{`You might also like`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/benefits-of-professional-training"
        }}>{`What are the benefits of Professional Training`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/what-are-react-hooks"
        }}>{`What are React "Hooks"?`}</a></li>
    </ul>
    <h2 {...{
      "id": "the-gist"
    }}><a parentName="h2" {...{
        "href": "#the-gist",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`The gist`}</h2>
    <p>{`React is a tool that helps us make Web Applications. So let's start with that -- What is a Web Application?`}</p>
    <h2 {...{
      "id": "where-did-the-idea-of-web-applications-come-from"
    }}><a parentName="h2" {...{
        "href": "#where-did-the-idea-of-web-applications-come-from",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Where did the idea of Web Applications come from?`}</h2>
    <p>{`From 2005 to 2010, you may have noticed that websites got a lot more advanced. They became much more than just places to read information. With some, you could actually `}<em parentName="p">{`do`}</em>{` things. Social Media platforms started popping up, you could look at interactive maps in the browser, and you could even to spreadsheets and word processing with tools like Google Drive (formerly Google Docs).`}</p>
    <p>{`As Web Developers, we started to use terminology to distinguish between traditional "websites" and these much more advanced sites. We started calling the more advanced ones "Web Applications" because they reminded us of the scale, effort, and technology practices that goes into traditional software applications that you would install on your computer. But a Web Application doesn't need to be installed, it just runs in the browser. In a sense, a Web Application is just a website, but it's technology is far more advanced and the effort to make one is much greater. For example, facebook.com is a Web Application, so is twitter.com, netflix.com and even your bank has a Web Application. Sometimes the lines between "websites and web applications" is a little blurry. For example, if you went to netflix.com, you're going to be looking at their marketing website that tries to show off their product and get you to sign up. But once you signup and login, you're now looking at their Web Application. For the most part, this distinction is not something average consumers talk about, they're terms that web developers use.`}</p>
    <p>{`It's also important to distinguish that a Web Application is not the same thing as a Native Application. When you log into netflix.com you're in the browser, so this is a Web Application. But Netflix also has a downloadable app for your phone or computer that you install. That is their "Native" Application.`}</p>
    <h2 {...{
      "id": "so-where-does-react-come-in"
    }}><a parentName="h2" {...{
        "href": "#so-where-does-react-come-in",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`So where does React come in?`}</h2>
    <p>{`In the 2010-2013 time period, Facebook was one of the leaders in the efforts to make their website more "app like". Facebook was pushing the envelope to create a super rich interactive experience for their users. At the time, existing technologies were insufficient for achieving their goals so they made their own technology which would eventually be called React.`}</p>
    <h2 {...{
      "id": "react-is-free-to-use"
    }}><a parentName="h2" {...{
        "href": "#react-is-free-to-use",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`React is free to use`}</h2>
    <p>{`Even though Facebook created React for themselves originally, they "open sourced" it in 2013. This just means that they made it available for everyone in the world to use and developers can even read all its source code to see how it's built. They also made the license for it free.`}</p>
    <p>{`So what does Facebook get out of it? Out of all the developers and companies who use React, we find fixes to make it better and help improve it as we use it ourselves. Then Facebook gets to use those improvements too, so it's a win-win.`}</p>
    <h2 {...{
      "id": "react-is-super-popular"
    }}><a parentName="h2" {...{
        "href": "#react-is-super-popular",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`React is super popular`}</h2>
    <p>{`This can matter sometimes because if you're trying to grow your team, just know there are lots of developers out there interested in doing React.`}</p>
    <h2 {...{
      "id": "whos-using-react"
    }}><a parentName="h2" {...{
        "href": "#whos-using-react",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Who's using React?`}</h2>
    <p><a parentName="p" {...{
        "href": "/brands"
      }}>{`Lots of companies are using React`}</a>{`. From banks to airlines, universities, and governments to startups and even giant tech companies like Google, Apple, Netflix, AirBnB, PayPal, IBM, Microsoft, AT&T, and many more. React has risen to be the preferred tool for building Web Applications by many.`}</p>
    <h2 {...{
      "id": "is-react-easy-to-learn"
    }}><a parentName="h2" {...{
        "href": "#is-react-easy-to-learn",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Is React easy to learn?`}</h2>
    <p>{`This is a little more subjective. Remember, Web Applications exist in the browser. As it turns out, browsers support one programming language which is JavaScript. Unlike "server-side programming" where developers can build server software with many choices of languages, in the browser we can only do JavaScript (or what we call "client-side programming"). React itself `}<em parentName="p">{`is`}</em>{` JavaScript. React is a JavaScript library which just means it's a bunch of JavaScript code already made for you. So "React" is just a brand name for this pre-packaged JavaScript code that helps developers. Think of libraries like React as being like a "head start". One could build a Web Application from plain JavaScript, or they could use a head start to be more efficient. `}</p>
    <p>{`Therefore, React being easy to learn or not depends on how well someone already knows how to program and specifically how to program in JavaScript. Even then, it's still fairly subjective since programmers tend to prefer various programming techniques over others and all libraries are opinionated on how they do things. The good news is, as far as programming languages are concerned, JavaScript is fairly easy to get started with.`}</p>
    <h2 {...{
      "id": "need-to-explain-react-to-someone"
    }}><a parentName="h2" {...{
        "href": "#need-to-explain-react-to-someone",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Need to explain React to someone?`}</h2>
    <p>{`Please send them to this page. Or if you want to explain React to someone, perhaps a good analogy works...`}</p>
    <p>{`Imagine building a house. You need materials and tools right? So you go down and buy them at the store. Even though you'd say you're building the house from scratch, It's not like you have to make your own hammers and nails, or even chop down trees to make your own lumber. The tools and materials you would get from the store are so general that they allow you to make almost anything, and they give you a big head start.`}</p>
    <p>{`This is just like React. Instead of building a Web Application from scratch, you can use tools like React to give you a big head-start. And just as with the analogy about tools for houses, web tools have evolved over time and React is seen by many as the best and most modern tool for the job.`}</p>
    <p>{`This "head start" idea in programming is nothing new. We generally call these head starts either "libraries" or "frameworks". There have been lots of JavaScript libraries and frameworks that have all tried to help developers create Web Apps. But React was novel because it did things in a new and innovative way. Here are just some of the companies using React and have asked us to help train their teams:`}</p>
    <AllBrands mdxType="AllBrands" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      